import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import "../index.css"

import { Dialog } from 'primereact/dialog'
import { Tooltip } from "primereact/tooltip";
import { Checkbox } from "primereact/checkbox";

import { Button, CalendarField, CheckboxField, TextAreaField, TextInputField } from '../../../../helpers'

import ViewAdjustmentNote from '../../../../common/ViewAdjustmentNote'

import GrnConfirmModal from './GrnConfirmModal'

import { raiseToast } from '../../../../services/redux/reducers/toast/toast'
import { fetchIncoTerms} from "../../../../services/redux/reducers/commonThunk";

import { round } from '../../../../utils'
import { getDateString } from '../../../../utils'

import { getPMCompanyConfig } from '../../../../setup/pmCompanyConfig';

const initialPaymentModeOptions = ['BANK TRANSFER', 'CASH', 'CREDIT', 'CHEQUE']


const GRNTable = (props) => {
    const { 
        index,
        sellerPIPunchItems, 
        adjustmentNote, 
        adjustmentNoteItems, 
        buyerReq,
        materialDetails, 
        orderTypes,
        sellerPO,
        sellerPOItems,
        sellerPIPunch, 
        handleViewClick, 
        sellerGRNQCPunch, 
        handleGRNClick, 
        handleInputChange, 
        handleProcessedChange, 
        handleInputDateChange,
        setSellerPIPunchItems,
        isInvoiceEnableForPMBranch,
        approvalInstances,
        setSelectedPIPunchItemIds,
        handleSelect,
        selectedPIPunchIds,
        sellerBillAddrDetails,
        sellerCompany
    } = props

    const incoTerms = useSelector((state) => state.common.incoTerms)

    const [visibleViewAdjustmentNote, setVisibleViewAdjustmentNote] = useState(false)
    const [visibleSDNRemarks, setVisibleSDNRemarks] = useState(false)
    const [sdnRemarks, setSDNRemarks] = useState(false)
    const [processedDate, setProcessedDate] = useState(null)
    const [updatedSellerPIPunchItems, setUpdatedSellerPIPunchItems] = useState(props.sellerPIPunchItems)
    const [initialSellerPIPunchItems, setInitialSellerPIPunchItems] = useState(props.sellerPIPunchItems)
    const [allProcessed, setAllProcessed] = useState(false)
    const [isGrnConfirmModalVisible, setIsGrnConfirmModalVisible] = useState(false)
    const [sellerPoCreatedAtDate, setSellerPoCreatedAtDate] = useState(null)
    const [leadTime, setLeadTime] = useState(null)
    const [incoTerm, setIncoTerm] = useState("")
    const [paymentModeOptions, setPaymentModeOptions] = useState(initialPaymentModeOptions)

    const userDetails = useSelector(state => state.userDetails)
    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    useEffect(()=>{
        dispatch(fetchIncoTerms())
    },[])

    useEffect(()=>{
        if(sellerPO && sellerPIPunch){
            setSellerPoCreatedAtDate(sellerPO?.createdAt)

            const relatedIncoTerm = incoTerms?.find(eachIncoTerm => eachIncoTerm?.incoTermId == sellerPO?.incoTermId)
            const leadTime = sellerPOItems[0].leadTime

            setLeadTime(leadTime)
            if(relatedIncoTerm){
                setIncoTerm(relatedIncoTerm?.incoTerm)
            }
        }
    },[sellerPIPunch])

    const dispatch = useDispatch()
    const usersData = useSelector(state => state.userDetails)

    const relatedSellerGRNQCPunch = sellerGRNQCPunch.filter(eachGRNPunch => eachGRNPunch.sellerPIPunchId === sellerPIPunch.sellerPIPunchId)
    const relatedSellerPIPunchItems = sellerPIPunchItems?.filter(eachSellerPIPunchItem => eachSellerPIPunchItem?.sellerPIPunchId === sellerPIPunch?.sellerPIPunchId)?.sort((a, b) => a.docNo - b.docNo)
    
    const handleGRN = (sellerPIPunchId) => {
        const activeRoleId = usersData?.activeRoleId
        const relatedUserCompany = usersData?.rolesList?.find(eachRole => eachRole?.userRoleId === activeRoleId)
        
        let relatedSellerPIPunchItems = sellerPIPunchItems.filter(eachSellerPIPunchItem =>{
            const relatedSellerPIPunch = sellerPIPunch
            const relatedSellerGRNQcPunches = sellerGRNQCPunch?.filter(eachGRNPunch => (eachGRNPunch.sellerPIPunchItemId === eachSellerPIPunchItem.sellerPIPunchItemId && eachGRNPunch.sellerPIPunchId === eachSellerPIPunchItem.sellerPIPunchId))
            delete eachSellerPIPunchItem.createdAt
            delete eachSellerPIPunchItem.updatedAt
            if (relatedSellerGRNQcPunches.length > 1){
                relatedSellerGRNQcPunches?.sort((a, b) => b.sellerGRNQCPunchId - a.sellerGRNQCPunchId)
            }
            eachSellerPIPunchItem.createdBy = usersData.userId
            eachSellerPIPunchItem.updatedBy = usersData.userId
            if (!eachSellerPIPunchItem.receivedQuantity){
                eachSellerPIPunchItem.receivedQuantity = 0
            }
            if (!eachSellerPIPunchItem.acceptedQuantity){
                eachSellerPIPunchItem.acceptedQuantity = 0
            }
            if (!eachSellerPIPunchItem.rejectedQuantity){
                eachSellerPIPunchItem.rejectedQuantity = 0
            }
            if (!eachSellerPIPunchItem.shortQuantity){
                eachSellerPIPunchItem.shortQuantity = 0
            }
            eachSellerPIPunchItem.pmCompanyId = relatedUserCompany?.pmCompanyId
            eachSellerPIPunchItem.pmBranchId = relatedUserCompany?.branchId

            if (relatedSellerPIPunch.isProcessed){
                if (eachSellerPIPunchItem.sellerPIPunchId === sellerPIPunchId && eachSellerPIPunchItem.processedDate){
                    if (relatedSellerGRNQcPunches.length > 0){
                        eachSellerPIPunchItem.receivedQuantity = relatedSellerGRNQcPunches[0]?.receivedQuantity + parseFloat(eachSellerPIPunchItem.receivedQuantity)
                        eachSellerPIPunchItem.rejectedQuantity = relatedSellerGRNQcPunches[0]?.rejectedQuantity + parseFloat(eachSellerPIPunchItem.rejectedQuantity)
                        eachSellerPIPunchItem.acceptedQuantity = parseFloat(eachSellerPIPunchItem.receivedQuantity) - parseFloat(eachSellerPIPunchItem?.rejectedQuantity)
                        eachSellerPIPunchItem.shortQuantity = eachSellerPIPunchItem?.qty - parseFloat(eachSellerPIPunchItem.receivedQuantity)
                        return eachSellerPIPunchItem
                    }else {
                        if (eachSellerPIPunchItem.receivedQuantity > 0){
                            eachSellerPIPunchItem.acceptedQuantity = parseFloat(eachSellerPIPunchItem.receivedQuantity) - parseFloat(eachSellerPIPunchItem?.rejectedQuantity)
                        }
                        eachSellerPIPunchItem.shortQuantity = eachSellerPIPunchItem?.qty - parseFloat(eachSellerPIPunchItem.receivedQuantity)
                        return eachSellerPIPunchItem
                    }
                }
            } else {
                if (eachSellerPIPunchItem.sellerPIPunchId === sellerPIPunchId && eachSellerPIPunchItem.processedDate && (eachSellerPIPunchItem.receivedQuantity || eachSellerPIPunchItem.acceptedQuantity || eachSellerPIPunchItem.rejectedQuantity || eachSellerPIPunchItem.shortQuantity)){
                    if (relatedSellerGRNQcPunches.length > 0){
                        eachSellerPIPunchItem.receivedQuantity = parseFloat(eachSellerPIPunchItem.receivedQuantity) + relatedSellerGRNQcPunches[0]?.receivedQuantity
                        eachSellerPIPunchItem.acceptedQuantity = parseFloat(eachSellerPIPunchItem.acceptedQuantity) + relatedSellerGRNQcPunches[0]?.acceptedQuantity
                        eachSellerPIPunchItem.rejectedQuantity = parseFloat(eachSellerPIPunchItem.rejectedQuantity) + relatedSellerGRNQcPunches[0]?.rejectedQuantity
                        eachSellerPIPunchItem.shortQuantity = parseFloat(eachSellerPIPunchItem.shortQuantity) + relatedSellerGRNQcPunches[0]?.shortQuantity
                        return eachSellerPIPunchItem
                    } else {
                        eachSellerPIPunchItem.receivedQuantity = parseFloat(eachSellerPIPunchItem.receivedQuantity)
                        eachSellerPIPunchItem.acceptedQuantity = parseFloat(eachSellerPIPunchItem.acceptedQuantity)
                        eachSellerPIPunchItem.rejectedQuantity = parseFloat(eachSellerPIPunchItem.rejectedQuantity)
                        eachSellerPIPunchItem.shortQuantity = parseFloat(eachSellerPIPunchItem.shortQuantity)
                        return eachSellerPIPunchItem
                    }
                }
            }
        })

        if (relatedSellerPIPunchItems.length === 0){
            return dispatch(raiseToast({severity:'warn', detail: '', life: 3000}))   
        }

        const allProcessed = relatedSellerPIPunchItems.every(eachSellerPIPunchItem => {
            return parseFloat(eachSellerPIPunchItem.acceptedQuantity) + parseFloat(eachSellerPIPunchItem?.rejectedQuantity) + parseFloat(eachSellerPIPunchItem?.shortQuantity) === parseFloat(eachSellerPIPunchItem?.qty)
        })    

        const isCalculationsMisMatched = relatedSellerPIPunchItems.some(eachSellerPIPunchItem => {
            return parseFloat(eachSellerPIPunchItem.receivedQuantity) < parseFloat(eachSellerPIPunchItem?.acceptedQuantity) + parseFloat(eachSellerPIPunchItem?.rejectedQuantity)
        })

        const isProcessedDatePresent = relatedSellerPIPunchItems.every(eachSellerPIPunchItem => eachSellerPIPunchItem?.processedDate)
        let isShortOrRejectQuantityAvailable = relatedSellerPIPunchItems?.some(eachSellerPIPunchItem => eachSellerPIPunchItem?.shortQuantity || eachSellerPIPunchItem?.rejectedQuantity)
        setUpdatedSellerPIPunchItems(relatedSellerPIPunchItems)
        setAllProcessed(allProcessed)

        if (isCalculationsMisMatched){
            return dispatch(raiseToast({severity:'warn', detail: 'Check the Quantities as it has Some mismatch.', life: 3000}))   
        }

        if (!isProcessedDatePresent){
            return dispatch(raiseToast({severity:'error', detail: 'Please Enter the Processed Date.', life: 3000}))   
        }

        if (isShortOrRejectQuantityAvailable && allProcessed){
            dispatch(raiseToast({severity:'warn', detail: 'Seller Debit Note Will be Created for Short/Rejected Quantity', life: 3000}))   
            setVisibleSDNRemarks(true)
        }
        else{
            setIsGrnConfirmModalVisible(true)
        }

        let updatePaymentModeOptions = paymentModeOptions
        let totalAcceptedValue = 0
        relatedSellerPIPunchItems.forEach(eachSellerPIPunchItem =>  {
            const relatedSellerPOItem = sellerPOItems.find(eachSellerPOItem => eachSellerPOItem.sellerPOItemId === eachSellerPIPunchItem.sellerPOItemId)
            totalAcceptedValue += parseFloat(eachSellerPIPunchItem.acceptedQuantity) * relatedSellerPOItem.unitPrice
        }) 

        if(totalAcceptedValue < 50000){
            updatePaymentModeOptions = paymentModeOptions.filter(eachPaymentMode => {
                if(eachPaymentMode === "CHEQUE"){
                    return false
                }
                return true
            })
        }
        else{
            updatePaymentModeOptions = paymentModeOptions.filter(eachPaymentMode => {
                if(eachPaymentMode === "CHEQUE" && sellerCompany.preferredPaymentMode === "BANK_TRANSFER"){
                    return false
                }
                return true
            })
        }

        setPaymentModeOptions(updatePaymentModeOptions)
        //setIsGrnConfirmModalVisible(true)
    }

    const handleAcceptClick = (emailObj, sellerPIPunchId, paymentMode) => {   
        handleGRNClick({emailObj, sellerPIPunchId, relatedSellerPIPunchItems: updatedSellerPIPunchItems, allProcessed, selectedPaymentMode: paymentMode})
        setIsGrnConfirmModalVisible(false)
        setProcessedDate(null)
    }

    const handleRejectClick = () => {
        setIsGrnConfirmModalVisible(false)
        let updatedSellerPIPunchItems = initialSellerPIPunchItems?.map(eachSellerPIPunchItem => {
            delete eachSellerPIPunchItem.acceptedQuantity
            delete eachSellerPIPunchItem.rejectedQuantity
            delete eachSellerPIPunchItem.receivedQuantity
            delete eachSellerPIPunchItem.shortQuantity
            return {...eachSellerPIPunchItem, processedDate: processedDate}
        })
        setSellerPIPunchItems(updatedSellerPIPunchItems)
    }
    
    let sellerPIDate = getDateString(sellerPIPunch?.sellerPIDate)


    let relatedAdjustmentNotes = adjustmentNote?.map(eachAdjustmentNote => {
        let relatedAdjustmentNoteItems = adjustmentNoteItems?.filter(eachAdjustmentNoteItem => eachAdjustmentNoteItem?.adjustmentNoteId === eachAdjustmentNote?.adjustmentNoteId)
        return {...eachAdjustmentNote, adjustmentNoteItems: relatedAdjustmentNoteItems}
    })

    let relatedOrderType = orderTypes?.find(eachOrderType => eachOrderType?.orderTypeId === buyerReq?.orderTypeId)

    let orderType = ""
    if (relatedOrderType?.orderTypeId){
        orderType = relatedOrderType?.orderType
    }

    if (sellerPO?.companyId === 1){
        orderType = "Use From Stock"
    }

    let areServiceHSNsProducts = false
    if (!isInvoiceEnableForPMBranch) {
        const sellerPIPunchItemWithQty = relatedSellerPIPunchItems.filter(eachPIPunchItem => sellerPIPunch?.isProcessed || parseFloat(eachPIPunchItem?.acceptedQuantity)>0 || parseFloat(eachPIPunchItem?.receivedQuantity)>0 || parseFloat(eachPIPunchItem?.shortQuantity)>0 || parseFloat(eachPIPunchItem?.rejectedQuantity)>0)
        areServiceHSNsProducts = sellerPIPunchItemWithQty.every(eachPIPunchItem => {
            const relatedSellerPOItem = sellerPOItems.find(eachPOItem => eachPOItem.sellerPOItemId === eachPIPunchItem.sellerPOItemId)

            if (relatedSellerPOItem.HSNCode.toString().slice(0, 2) === '99') {
                return true
            }
            return false
        })
    }

    let grnDisableCond = true 
    if(isInvoiceEnableForPMBranch){
        grnDisableCond = false
    }
    else{
        if(areServiceHSNsProducts){
            grnDisableCond = false
        }
    }

    grnDisableCond = grnDisableCond || sellerPIPunch?.allProcessed || sellerPIPunch?.statusId === 2
    const relatedApprovalInstance = approvalInstances?.find(eachApprovalInstance => eachApprovalInstance?.docNo === sellerPIPunch?.docNo)

    const getGenerateGRNHTML = (sellerPIPunch) => {
        if (relatedApprovalInstance?.statusId === 12){
            return <h4 className="align-self-center mr-2 mt-3">Approval Request is Pending</h4> 
        }else{
            return (
                <div className="flex mb-2 align-items-end ml-2">
                    <Button className="small-btn" label="GENERATE GRN" permissions={[23]} disabled={grnDisableCond} onClick={() => handleGRN(sellerPIPunch?.sellerPIPunchId)}/> {/*  */}
                </div>
            )
        }
    }

    const handleSDNRemarks = (event) => {
        setSDNRemarks(event.target.value)
    }
    
    const handleSDNRemarksOnHide = () => {
        setVisibleSDNRemarks(false) 
        setSDNRemarks(null)
    }

    const handleSDNRemarksContinue = () => {
        if(!sdnRemarks){
            return dispatch(raiseToast({severity:'warn', detail: 'Please enter remarks for Seller debit note!', life: 3000})) 
        }

        setVisibleSDNRemarks(false)
        setIsGrnConfirmModalVisible(true)
    }

    const sdnRemarksFooter = () => {
        return (
            <div className="mt-2">
                <Button label="Cancel" severity="danger" outlined onClick={handleSDNRemarksOnHide} />
                <Button label="Continue" outlined onClick={handleSDNRemarksContinue} />
            </div>
        )
    }
    
    const handleOnHideConfirmModal = () => {
        setIsGrnConfirmModalVisible(false)
        setPaymentModeOptions(initialPaymentModeOptions)
        handleRejectClick()
    }


    return (
        <>
            <Dialog header="GRN & QC" visible={isGrnConfirmModalVisible} style={{ width: '40vw', minHeight: "20vh" }} onHide={handleOnHideConfirmModal}>
                <GrnConfirmModal 
                    sellerPO={sellerPO}
                    orderType={relatedOrderType}
                    handleAcceptClick={handleAcceptClick}
                    handleRejectClick={handleRejectClick}
                    handleGRN={handleGRN} 
                    sellerPIPunchId={sellerPIPunch?.sellerPIPunchId} 
                    leadTime={leadTime} 
                    sellerPoCreatedAtDate={sellerPoCreatedAtDate} 
                    setIsGrnConfirmModalVisible={setIsGrnConfirmModalVisible} 
                    sellerCompany={sellerCompany}
                    paymentModeOptions={paymentModeOptions}
                    updatedSellerPIPunchItems={updatedSellerPIPunchItems}
                    materialDetails={materialDetails} 
                    sellerBillAddrDetails={sellerBillAddrDetails}
                />
            </Dialog>

            <Dialog header="" visible={visibleSDNRemarks} style={{ width: '40vw', height: '40vh' }} onHide={handleSDNRemarksOnHide} footer={sdnRemarksFooter}>
                <TextAreaField name="remarks" labelText="" rows={7} cols={10} placeholder="Please enter remarks for seller debit note" value={sdnRemarks} onChange={handleSDNRemarks} maxLength={1000} />
            </Dialog>

            <div className="flex flex-row justify-content-between">
                <div className="flex" style={{ fontSize : "14px"}}>
                    <p className='pi-punch-no'>{index+1}</p>
                    <a className={`pi-product custom-tooltip-${sellerPIPunch?.sellerPIPunchId}`} target="_blank" style={{cursor: "pointer"}}>{sellerPIPunch?.sellerPINumber ? sellerPIPunch?.sellerPINumber : sellerPIPunch?.docNo}</a>
                    <p className='pi-punch-no ml-2'>{relatedOrderType?.orderTypeId && ` | ${orderType}`} {sellerPO?.expenseCategoryId && " | EXPENSE"}</p>
                    <p className='pi-date'>{sellerPIPunch?.sellerPIDate ? ` | ${sellerPIDate}` : ""}</p>
                    <Tooltip target={`.custom-tooltip-${sellerPIPunch?.sellerPIPunchId}`} position="top" autoHide>
                        <>
                            <p className="m-0 mb-1"> <b>Vendor {pmCompanyConfig.GSTINLabel}:</b> {sellerBillAddrDetails.gstinCode}</p><br />
                            <p className="m-0 mb-1"><b>Inco Terms:</b> {incoTerm}</p>
                        </>
                    </Tooltip>
                </div>
                <div className="flex">
                    {
                        adjustmentNote?.length > 0 && 
                        <>
                            <Button className="debit-note-btn" label="DN" rounded onClick={() => {setVisibleViewAdjustmentNote(true)}} />
                            <ViewAdjustmentNote 
                                type="Debit Note" 
                                adjustmentNote={relatedAdjustmentNotes} 
                                adjustmentNoteItems={adjustmentNoteItems} 
                                materialDetails={materialDetails} 
                                sellerPIPunchItems={sellerPIPunchItems} 
                                visibleViewAdjustmentNote={visibleViewAdjustmentNote} 
                                setVisibleViewAdjustmentNote={setVisibleViewAdjustmentNote}
                            />
                        </>
                    }
                </div>
            </div>

            <div className="flex flex-wrap py-2 w-full px-4 grn-table">
                <div className="flex header-style">
                    <div className="mb-2" style={{ width: '3%' }}>
                    <Checkbox 
                        onChange={e => handleSelect(sellerPIPunch.sellerPIPunchId, e.target.checked)} 
                        checked={selectedPIPunchIds.includes(sellerPIPunch.sellerPIPunchId)}
                        disabled={sellerPIPunch?.allProcessed  || sellerPIPunch?.statusId === 2}
                    />
                    </div>
                    <div className="mb-2" style={{ width: '28%', textAlign: "start"}}>Product</div>
                    <div className="mb-2" style={{ width: '10%',}}>Remark</div>
                    <div className="mb-2" style={{ width: '10%' }}>PI Punched</div>
                    <div className="mb-2" style={{ width: '10%' }}>GRN Done</div>
                    <div className="mb-2" style={{ width: '10%' }}>Accepted</div>
                    <div className="mb-2" style={{ width: '10%' }}>Rejected</div>
                    <div className="mb-2" style={{ width: '10%' }}>Short</div>
                    <div className="mb-2" style={{ width: '10%' }}>Cur. GRN</div>
                    <div className="mb-2" style={{ width: '10%' }}>Cur. Accepted</div>
                    <div className="mb-2" style={{ width: '10%' }}>Cur. Rejected</div>
                    <div className="mb-2" style={{ width: '10%' }}>Cur. Short</div>
                </div>
                {
                    relatedSellerPIPunchItems?.map(eachSellerPIPunchItem => {
                        const relatedMaterialData = materialDetails?.find(eachMaterial => eachMaterial.materialId === eachSellerPIPunchItem.materialId)
                        const relatedSellerGRNQcPunches = sellerGRNQCPunch?.filter(eachGRNPunch => eachGRNPunch.sellerPIPunchItemId === eachSellerPIPunchItem.sellerPIPunchItemId)
                        relatedSellerGRNQcPunches?.sort((a, b) => b.sellerGRNQCPunchId - a.sellerGRNQCPunchId)
                        const remainingQuantity =  relatedSellerGRNQcPunches[0] ? eachSellerPIPunchItem?.qty - relatedSellerGRNQcPunches[0]?.receivedQuantity - relatedSellerGRNQcPunches[0]?.shortQuantity : eachSellerPIPunchItem?.qty
                        let currentReceivableQuantity = remainingQuantity
                        let currentShortableQuantity = relatedSellerGRNQcPunches[0] ? parseFloat(remainingQuantity) + relatedSellerGRNQcPunches[0]?.receivedQuantity : parseFloat(remainingQuantity)
                        let currentAcceptableQuantity = parseFloat(eachSellerPIPunchItem?.qty - remainingQuantity)
                        let currentRejectableQuantity = parseFloat(eachSellerPIPunchItem?.qty - remainingQuantity)
                        if (eachSellerPIPunchItem?.receivedQuantity){
                            currentShortableQuantity -= parseFloat(eachSellerPIPunchItem?.receivedQuantity)
                            currentAcceptableQuantity += parseFloat(eachSellerPIPunchItem?.receivedQuantity)
                            currentRejectableQuantity += parseFloat(eachSellerPIPunchItem?.receivedQuantity)
                        }
                        if (eachSellerPIPunchItem?.acceptedQuantity){
                            currentRejectableQuantity -= parseFloat(eachSellerPIPunchItem?.acceptedQuantity)
                        }
                        if (eachSellerPIPunchItem?.rejectedQuantity){
                            currentAcceptableQuantity -= parseFloat(eachSellerPIPunchItem?.rejectedQuantity)
                        }
                        if (eachSellerPIPunchItem?.shortQuantity){
                            currentReceivableQuantity -= parseFloat(eachSellerPIPunchItem?.shortQuantity)
                        }
                        if (relatedSellerGRNQcPunches[0]){
                            currentShortableQuantity = eachSellerPIPunchItem?.qty - relatedSellerGRNQcPunches[0]?.receivedQuantity - relatedSellerGRNQcPunches[0]?.shortQuantity
                            currentAcceptableQuantity = relatedSellerGRNQcPunches[0]?.receivedQuantity - relatedSellerGRNQcPunches[0]?.acceptedQuantity - relatedSellerGRNQcPunches[0]?.rejectedQuantity
                            currentRejectableQuantity = relatedSellerGRNQcPunches[0]?.receivedQuantity - relatedSellerGRNQcPunches[0]?.rejectedQuantity - relatedSellerGRNQcPunches[0]?.acceptedQuantity
                            if (eachSellerPIPunchItem?.receivedQuantity){
                                currentShortableQuantity -= parseFloat(eachSellerPIPunchItem?.receivedQuantity)
                                currentAcceptableQuantity += parseFloat(eachSellerPIPunchItem?.receivedQuantity)
                                currentRejectableQuantity += parseFloat(eachSellerPIPunchItem?.receivedQuantity)
                            }
                            if (eachSellerPIPunchItem?.acceptedQuantity){
                                currentRejectableQuantity -= parseFloat(eachSellerPIPunchItem?.acceptedQuantity)
                            }
                            if (eachSellerPIPunchItem?.rejectedQuantity){
                                currentAcceptableQuantity -= parseFloat(eachSellerPIPunchItem?.rejectedQuantity)
                            }
                        }
                        currentAcceptableQuantity = round(currentAcceptableQuantity)
                        currentReceivableQuantity = round(currentReceivableQuantity)
                        currentRejectableQuantity = round(currentRejectableQuantity)
                        currentShortableQuantity = round(currentShortableQuantity)
                       
                        const disabledCondition = ((eachSellerPIPunchItem?.qty === (relatedSellerGRNQcPunches[0]?.acceptedQuantity + relatedSellerGRNQcPunches[0]?.rejectedQuantity + relatedSellerGRNQcPunches[0]?.shortQuantity)) || eachSellerPIPunchItem?.statusId === 2)
                        const relatedSellerPOItem = sellerPOItems.find(eachPOItem => eachPOItem.sellerPOItemId === eachSellerPIPunchItem.sellerPOItemId)
                        return (
                            <div className="flex data-style" key={`sellerPIPuchItem-${eachSellerPIPunchItem.sellerPIPunchItemId}`}>
                                <div className="py-2" style={{ width: '28%', textAlign: "start", alignSelf: "center"}}>{relatedMaterialData?.materialId} | {relatedMaterialData?.productName} | {relatedMaterialData?.variantName} | {relatedMaterialData?.productSpecification}</div>
                                <div className="py-2" style={{ width: '10%' , alignSelf: "center"}}>{relatedSellerPOItem?.materialSpecRemark}</div>
                                <div className="py-2" style={{ width: '10%' , alignSelf: "center"}}>{eachSellerPIPunchItem?.qty}</div>
                                <div className="py-2" style={{ width: '10%' , alignSelf: "center"}}>{relatedSellerGRNQcPunches[0] ? relatedSellerGRNQcPunches[0]?.receivedQuantity : 0}</div>
                                <div className="py-2" style={{ width: '10%' , alignSelf: "center"}}>{relatedSellerGRNQcPunches[0] ? relatedSellerGRNQcPunches[0]?.acceptedQuantity : 0}</div>
                                <div className="py-2" style={{ width: '10%' , alignSelf: "center"}}>{relatedSellerGRNQcPunches[0] ? relatedSellerGRNQcPunches[0]?.rejectedQuantity : 0}</div>
                                <div className="py-2" style={{ width: '10%' , alignSelf: "center"}}>{relatedSellerGRNQcPunches[0] ? relatedSellerGRNQcPunches[0]?.shortQuantity : 0}</div>
                                <div className="py-2 px-1" style={{ width: '10%', alignSelf: "center" }}>
                                    <TextInputField 
                                        name="receivedQuantity" 
                                        labelText="" 
                                        placeholder={`Upto ${currentReceivableQuantity > 0 ? currentReceivableQuantity : 0}`} 
                                        style={{ width: "" }} 
                                        disabled={disabledCondition} 
                                        value={eachSellerPIPunchItem?.receivedQuantity} 
                                        keyfilter={"pnum"} 
                                        onChange={e => handleInputChange(e, eachSellerPIPunchItem?.sellerPIPunchItemId, currentReceivableQuantity)} 
                                    />
                                </div>
                                <div className="py-2 px-1" style={{ width: '10%', alignSelf: "center" }}>
                                    <TextInputField 
                                        name="acceptedQuantity" 
                                        labelText="" 
                                        placeholder={`Upto ${currentAcceptableQuantity > 0 ? currentAcceptableQuantity : 0}`}  
                                        style={{ width: "" }} 
                                        disabled={disabledCondition} 
                                        value={eachSellerPIPunchItem?.acceptedQuantity} 
                                        keyfilter={"pnum"}
                                        onChange={e => handleInputChange(e, eachSellerPIPunchItem?.sellerPIPunchItemId, currentAcceptableQuantity)} 
                                    />
                                </div>
                                <div className="py-2 px-1" style={{ width: '10%', alignSelf: "center" }}>
                                    <TextInputField 
                                        name="rejectedQuantity" 
                                        labelText="" 
                                        placeholder={`Upto ${currentRejectableQuantity > 0 ? currentRejectableQuantity : 0}`} 
                                        style={{ width: "" }} 
                                        disabled={disabledCondition} 
                                        value={eachSellerPIPunchItem?.rejectedQuantity} 
                                        keyfilter={"pnum"} 
                                        onChange={e => handleInputChange(e, eachSellerPIPunchItem?.sellerPIPunchItemId, currentRejectableQuantity)} 
                                    />
                                </div>
                                <div className="py-2 px-1" style={{ width: '10%', alignSelf: "center" }}>
                                    <TextInputField 
                                        name="shortQuantity"
                                        labelText="" 
                                        placeholder={`Upto ${currentShortableQuantity > 0 ? currentShortableQuantity : 0}`}  
                                        style={{ width: "" }} 
                                        disabled={disabledCondition} 
                                        value={eachSellerPIPunchItem?.shortQuantity} 
                                        keyfilter={"pnum"} 
                                        onChange={e => handleInputChange(e, eachSellerPIPunchItem?.sellerPIPunchItemId, currentShortableQuantity)} 
                                    />
                                </div>
                            </div>
                        )
                    })
                }
            </div>

            <div className="flex justify-content-between px-4">
                {relatedSellerGRNQCPunch &&
                    <div className="flex flex-column align-items-left lg:col-2 lg:mb-0">
                        <a label="View History" style={{cursor : "pointer"}} onClick={() => handleViewClick(sellerPIPunch?.sellerPIPunchId)}>View History<i className={sellerPIPunch?.isHistoryVisible ? "pi pi-angle-up pl-2" : "pi pi-angle-down pl-2"}></i></a> 
                    </div>
                }
                <div className="flex flex-column lg:col-2 lg:mb-0" style={{ width: "20%" }}>
                    <CheckboxField name="isProcessed" inputId="processed" label="Mark As Processed" disabled={sellerPIPunch?.allProcessed  || sellerPIPunch?.statusId === 2} checked={sellerPIPunch?.isProcessed} onChange={e => handleProcessedChange(e, sellerPIPunch.sellerPIPunchId)}/>
                </div>
                <div className="flex flex-column mb-2 lg:col-2 lg:mb-0" style={{ width: "20%" }}>
                    <CalendarField name="processedDate" value={processedDate} labelText="" maxDate={new Date()} placeholder="Product Received Date"  showTime hourFormat="12" showIcon disabled={sellerPIPunch?.allProcessed || sellerPIPunch?.statusId === 2} onChange = {(e) =>{setProcessedDate(e.target.value) ;handleInputDateChange(e)}}/>
                </div>
                {
                    getGenerateGRNHTML(sellerPIPunch)
                }
            </div>
        </>
    )
}

export default GRNTable